espresso.constant = {
    jWindow: jQuery( window ),
    jHtml: jQuery( 'html' )
};
espresso.config = {
    pageLanguage: espresso.constant.jHtml.attr( 'lang' ),
    IntergerSeparator: espresso.constant.jHtml.data( 'integer-separator' ),
    DecimalSeparator: espresso.constant.jHtml.data( 'decimal-separator' ),
};
if ( espresso.config.IntergerSeparator === ' ' ) {
    espresso.config.regExpIntergerSeparator = new RegExp( '(\\s|&nbsp;)', 'g' );
}
else {
    espresso.config.regExpIntergerSeparator = new RegExp( '\\' + espresso.config.IntergerSeparator, 'g' );
}
if ( espresso.config.DecimalSeparator === ' ' ) {
    espresso.config.regExpDecimalSeparator = new RegExp( '(\\s|&nbsp;)', 'g' );
}
else {
    espresso.config.regExpDecimalSeparator = new RegExp( '\\' + espresso.config.DecimalSeparator, 'g' );
}
espresso.settings = {
    scrollSpeed: 500
};
